import { render, staticRenderFns } from "./InventoryColorFormat.vue?vue&type=template&id=77e98f7c&scoped=true&functional=true&"
import script from "./InventoryColorFormat.vue?vue&type=script&lang=js&"
export * from "./InventoryColorFormat.vue?vue&type=script&lang=js&"
import style0 from "./InventoryColorFormat.vue?vue&type=style&index=0&id=77e98f7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "77e98f7c",
  null
  
)

export default component.exports